import { useContext } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import AuthContext from '../../contexts/auth-context';
import AppContext from '../../contexts/app-context';
import MainNavigationStyle from './MainNavigation.module';
import { appLogoPath } from '../config/variables';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

const MainNavigation = ({toggleDrawer}) => {
  const classes = MainNavigationStyle();
  const authCtx = useContext(AuthContext);
  const appCtx = useContext(AppContext);
  const userRole = appCtx.userRole;
  const loggedInUser = authCtx.userProfile.user;

  const roleDisplayNames = {
    doctor: 'Physician',
    insurance_admin: 'Insurance Administrator',
    facility_admin: 'Facility Administrator',
    pharmacy_admin: authCtx?.userProfile?.pharmacy?.name || 'Pharmacy Administrator',
    patient: 'Patient',
  };

  const initials = loggedInUser?.name
    ?.split(' ')
    .map(n => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <Box sx={classes.header_container}>
      <Box sx={classes.res_nav_container}>
        <IconButton aria-label="side-panel" onClick={toggleDrawer(true)}>
          <MenuIcon fontSize="large" color="primary" />
        </IconButton>
        <img src={appLogoPath} alt="logo" style={classes.logo} />
      </Box>

      <Box sx={classes.header}>
        <Box sx={classes.userInfo}>
          <Avatar sx={classes.avatar}>{initials}</Avatar>
          <Box>
            <Typography component="h1" sx={classes.title}>
              {userRole === 'doctor' ? `Dr. ${loggedInUser.name}` : loggedInUser.name}
            </Typography>
            <Typography sx={classes.userRole}>
              {roleDisplayNames[userRole] || userRole}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MainNavigation;
